import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCachedTexts } from '../hooks/useCachedTexts';
import './WhoWeAre.css';

const WhoWeAre = () => {
  const { t } = useTranslation();
  const { getText } = useCachedTexts('home_who_we_are');
  return (
    <section className="who-we-are">
      <div className="who-we-are-container">
        <h2 className="who-we-are-title">{getText('heading', t('home.whoWeAre'))}</h2>
        <p className="who-we-are-text">
          {getText('description', t('home.whoWeAreDescription'))}
        </p>
        <Link to="/about" className="who-we-are-cta" onClick={() => window.scrollTo(0, 0)}>
          {getText('button', t('home.learnMore'))}
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </Link>
      </div>
    </section>
  );
};

export default WhoWeAre;
